export default {
  blue: '#0366D6',
}
